document.addEventListener('DOMContentLoaded', () => {
    const params = new URLSearchParams(window.location.search);
    const goal = params.get('goal');
    if (!goal) return;

    const goalMap = {
      'build-muscle': 'Build Muscle',
      'boost-energy': 'Boost Energy',
      'shred-slim': 'Shred & Slim',
    };

    const targetText = goalMap[goal];
    if (!targetText) return;

    let attempts = 0;
    const interval = setInterval(() => {
      attempts++;

      const matchingBox = [...document.querySelectorAll('.goal-box')].find(box => {
        return box.querySelector('.goal-text')?.textContent.trim() === targetText;
      });

      if (matchingBox) {
        clearInterval(interval);
        matchingBox.click();
      } else if (attempts >= 10) {
        clearInterval(interval);
      }
    }, 500);
  });